<template>
    <v-dialog v-model="dialog" max-width="520" persistent>
        <v-card>
            <v-toolbar dark color="primary" dense flat>
                <v-toolbar-title>{{ editando ? 'Editar pod' : 'Novo pod' }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pt-4">
                <v-form ref="form">
                    <v-row dense>
                        <v-col cols="8">
                            <v-text-field
                                v-model="form.host"
                                label="Host"
                                outlined
                                dense
                                :disabled="editando"
                                :rules="[v => !!v || 'Informe o host']"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.porta"
                                label="Porta"
                                type="number"
                                outlined
                                dense
                                :disabled="editando"
                                :rules="[v => !!v || 'Informe a porta']"
                            />
                        </v-col>
                    </v-row>

                    <div v-if="editando" class="caption grey--text mb-3">
                        Endereço é identidade: trocar host/porta aqui deixaria as instâncias
                        apontadas para este pod órfãs, sem que ninguém as tivesse movido. Para
                        mudar de endereço, crie outro pod e mova as instâncias.
                    </div>

                    <v-text-field
                        v-model="form.nome"
                        label="Nome"
                        outlined
                        dense
                        :rules="[v => !!v || 'Informe o nome']"
                    />

                    <v-row dense>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.capacidade_max"
                                label="Capacidade máxima"
                                type="number"
                                outlined
                                dense
                                hint="Vazio = sem teto declarado"
                                persistent-hint
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.ordem"
                                label="Ordem"
                                type="number"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>

                    <v-textarea
                        v-model="form.observacao"
                        label="Observação"
                        outlined
                        dense
                        rows="2"
                        class="mt-2"
                    />

                    <v-switch
                        v-model="form.ativo"
                        label="Ativo (aceita receber instâncias)"
                        dense
                        inset
                        hide-details
                    />
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn text @click="dialog = false">Cancelar</v-btn>
                <v-btn color="primary" :loading="salvando" @click="salvar">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PodDialog',

    data: () => ({
        dialog: false,
        salvando: false,
        editando: false,
        id: null,
        form: {},
    }),

    methods: {
        abrir(pod = null) {
            this.editando = !!pod;
            this.id = pod ? pod.id : null;

            this.form = pod
                ? {
                    host: pod.host,
                    porta: pod.porta,
                    nome: pod.nome,
                    capacidade_max: pod.capacidade_max,
                    ordem: pod.ordem,
                    observacao: pod.observacao,
                    ativo: pod.ativo,
                }
                : { host: '', porta: '', nome: '', capacidade_max: null, ordem: 0, observacao: '', ativo: true };

            this.dialog = true;

            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },

        async salvar() {
            if (!this.$refs.form.validate()) return;

            this.salvando = true;

            const payload = {
                ...this.form,
                porta: this.form.porta ? Number(this.form.porta) : null,
                capacidade_max: this.form.capacidade_max ? Number(this.form.capacidade_max) : null,
                ordem: Number(this.form.ordem || 0),
            };

            try {
                this.editando
                    ? await this.$http.put(`instancias-whatsapp/pods/${this.id}`, payload)
                    : await this.$http.post('instancias-whatsapp/pods', payload);

                this.notify('Pod salvo', 'success');
                this.dialog = false;
                this.$emit('salvo');
            } catch (e) {
                const msg = e.response && e.response.data && e.response.data.message;
                this.notify(msg || 'Não foi possível salvar o pod', 'error');
            }

            this.salvando = false;
        },
    },
};
</script>
